import React, { useState, useEffect } from 'react';
import { database } from "../../firebase";
import { ref, get, set } from 'firebase/database';
import { useContext } from 'react';
import { AuthContext } from "../../context/AuthContext";
import {
    Card,
    CardContent,
    CardMedia,
    Typography,
    TextField,
    Grid,
    Container,
    Box,
    Button,
    Snackbar,
    Alert
  } from '@mui/material';


  const WatchesImages = [
    { id: "SM-L305F", url: "/Images/SM-L305F.png" },
    { id: "SM-L310", url: "/Images/SM-L310.png" },
    { id: "SM-L315F", url: "/Images/SM-L315F.png" },
    { id: "SM-L705F", url: "/Images/SM-L705F.png" },
    { id: "SM-R910", url: "/Images/SM-R910.png" },
    { id: "SM-R915F", url: "/Images/SM-R915F.png" },
    { id: "SM-R930", url: "/Images/SM-R930.png" },
    { id: "SM-R935F", url: "/Images/SM-R935F.png" },
    { id: "SM-R940", url: "/Images/SM-R940.png" },
    { id: "SM-R945F", url: "/Images/SM-R945F.png" },
  ];
  
  
  
  const CustomUrlComponent = () => {
    const { currentUser } = useContext(AuthContext);
    const [watches, setWatches] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
  
    useEffect(() => {
      if (currentUser) {
        const watchesRef = ref(database, 'Watches/');
        get(watchesRef)
          .then((snapshot) => {
            if (snapshot.exists()) {
              const watchesData = snapshot.val();
              const filteredWatches = Object.values(watchesData)
                .filter(
                  (watch) =>
                    watch.companyId === currentUser.companyId &&
                    watch.locationId === currentUser.locationId &&
                    !watch.watchAssist // Exclude watches that are assist
                );
              setWatches(filteredWatches);
            } else {
              console.error('No watches found for the given company and location');
            }
          })
          .catch((error) => {
            console.error('Error fetching watches: ', error);
          });
      }
    }, [currentUser]);
    
    const handleDisplayNameChange = (watchId, newDisplayName) => {
      const updatedWatches = watches.map((watch) =>
        watch.watchId === watchId ? { ...watch, watchDisplayName: newDisplayName } : watch
      );
      setWatches(updatedWatches);
    };
  
    const handleSave = (watchId) => {
      const watchToSave = watches.find((w) => w.watchId === watchId);
      const watchRef = ref(database, `Watches/${watchId}`);
  
      set(watchRef, watchToSave)
        .then(() => {
          setSnackbar({
            open: true,
            message: "Watch display name updated successfully!",
            severity: "success"
          });
        })
        .catch((error) => {
          console.error('Error updating watchDisplayName:', error);
          setSnackbar({
            open: true,
            message: "Failed to update display name.",
            severity: "error"
          });
        });
    };
  
    const handleSearchChange = (event) => {
      setSearchQuery(event.target.value);
    };
  
    const filteredWatches = watches.filter((watch) =>
      watch.watchId.toLowerCase().includes(searchQuery.toLowerCase())
    );
  
    return (
      <Container>
        <Box mb={2}>
          <Typography variant="subtitle1" sx={{ fontWeight: 300, color: "text.secondary", mb: 1, mt: 2 }}>
            Edit watch details for location: <strong>{currentUser.locationName}</strong>
          </Typography>
  
          <TextField
            label="Search by Watch ID"
            variant="outlined"
            fullWidth
            value={searchQuery}
            onChange={handleSearchChange}
            sx={{ mt: 2 }}
          />
        </Box>
  
        <Grid container spacing={3}>
          {filteredWatches.map((watch) => (
            <Grid item xs={12} sm={6} md={4} key={watch.watchId}>
              <Card variant="outlined" sx={{ display: 'flex', flexDirection: 'column' }}>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginTop: '16px',
                  }}
                >
                  <CardMedia
                    component="img"
                    image={WatchesImages.find((image) => image.id === watch.deviceName)?.url || ""}
                    alt={watch.deviceName}
                    sx={{
                      width: 100,
                      height: 100,
                      borderRadius: '50%',
                      objectFit: 'cover',
                    }}
                  />
                </Box>
  
                <CardContent>
                  <Typography variant="h6">{watch.watchId}</Typography>
                  <Typography variant="h9">{watch.deviceName}</Typography>
                  <Typography variant="body2" color="textSecondary">
                    <span
                      style={{
                        fontWeight: 'bold',
                        color: watch.watchAssist ? 'green' : '#3F8EAC',
                      }}
                    >
                      {watch.watchAssist ? 'Assist' : 'Guardian'}
                    </span>
                  </Typography>
                  <TextField
                    label="Watch Display Name"
                    variant="outlined"
                    fullWidth
                    value={watch.watchDisplayName || ""}
                    onChange={(e) => handleDisplayNameChange(watch.watchId, e.target.value)}
                    sx={{ mt: 2 }}
                  />
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={() => handleSave(watch.watchId)}
                    sx={{ mt: 2 }}
                  >
                    Save
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
  
        <Snackbar
          open={snackbar.open}
          autoHideDuration={4000}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
          <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity} sx={{ width: '100%' }}>
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Container>
    );
  };
  
  export default CustomUrlComponent;